import { getQBOIntegrationURL } from 'pricing-pages-lib/utils/publicPageUrls';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { ENTERPRISE, FREE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
export const ADDITIONAL_SUBSCRIPTION = 'ADDITIONAL_SUBSCRIPTION';
export const CommerceFeatures = [{
  shortName: 'invoices',
  productLevelAvailability: [FREE, STARTER, PROFESSIONAL, ENTERPRISE],
  hasCheckMark: true
}, {
  shortName: 'paymentLinks',
  productLevelAvailability: [FREE, STARTER, PROFESSIONAL, ENTERPRISE]
}, {
  shortName: 'quotes',
  productLevelAvailability: [FREE, STARTER, PROFESSIONAL, ENTERPRISE]
}, {
  shortName: 'subscriptions',
  productLevelAvailability: [FREE, STARTER, PROFESSIONAL, ENTERPRISE]
}, {
  shortName: 'b2bCheckout',
  productLevelAvailability: [FREE, STARTER, PROFESSIONAL, ENTERPRISE]
}, {
  shortName: 'products',
  productLevelAvailability: [FREE, STARTER, PROFESSIONAL, ENTERPRISE]
}, {
  shortName: 'stripePayment',
  productLevelAvailability: [FREE, STARTER, PROFESSIONAL, ENTERPRISE],
  embeddedLink: {
    isExternal: true,
    url: 'https://legal.hubspot.com/stripe-integration-beta-terms',
    name: 'terms-and-conditions'
  }
}, {
  shortName: 'eSign',
  productLevelAvailability: [STARTER, PROFESSIONAL, ENTERPRISE]
}, {
  shortName: 'payments',
  productLevelAvailability: [STARTER, PROFESSIONAL, ENTERPRISE],
  embeddedLink: {
    isExternal: true,
    url: 'https://legal.hubspot.com/payments-terms-of-use',
    name: 'terms-and-conditions'
  }
}, {
  shortName: 'customBillingAutomation',
  productLevelAvailability: [PROFESSIONAL, ENTERPRISE]
}, {
  shortName: 'simpleRevenueReporting',
  productLevelAvailability: [FREE, STARTER, PROFESSIONAL, ENTERPRISE]
}, {
  shortName: 'customRevenueReporting',
  productLevelAvailability: [PROFESSIONAL, ENTERPRISE]
}, {
  shortName: 'quickbooks',
  productLevelAvailability: [FREE, STARTER, PROFESSIONAL, ENTERPRISE],
  hasCheckMark: true,
  embeddedLink: {
    isExternal: true,
    url: getQBOIntegrationURL(),
    name: 'terms-and-conditions'
  }
}];
const EnrolledProductLineFeatureMap = {
  [COMMERCE]: CommerceFeatures
};
export const getEnrolledProductLineFeatureAccessLevels = productLine => {
  const features = EnrolledProductLineFeatureMap[productLine];
  const accessLevels = features.reduce((set, feature) => {
    feature.productLevelAvailability.forEach(level => {
      if (level === FREE) {
        set.add(FREE);
      } else {
        set.add(ADDITIONAL_SUBSCRIPTION);
      }
    });
    return set;
  }, new Set());
  return [...accessLevels];
};
export const getFeaturesAtProductLevel = (productLine, productLevels) => {
  return CommerceFeatures.filter(feature => {
    return productLevels.find(level => {
      return feature.productLevelAvailability.includes(level);
    }) || false;
  });
};
export const hasEnrolledFeatureAtAccessLevel = (feature, accessLevel) => {
  if (accessLevel === FREE) {
    return feature.productLevelAvailability.includes(FREE);
  }
  if (accessLevel === ADDITIONAL_SUBSCRIPTION) {
    return Boolean(feature.productLevelAvailability.find(productLevel => {
      return productLevel === STARTER || productLevel === PROFESSIONAL || productLevel === ENTERPRISE;
    }));
  }
  return false;
};